import React, { memo, useState, useEffect } from 'react';
import { Transition } from 'react-transition-group';
import PropTypes from 'prop-types';
import FormsButton from './FormsButton/FormsButton';
import DialogModal from "../DialogModal/DialogModal";
import EmbeddedForm from "../../EmbeddedForm/EmbeddedForm";

import './FormModal.scss';
const FormModal = memo(
  ({
    currentForm,
    currentTour,
    closeModal,
    publicTour,
    shouldShowForm,
  }) => {
    const [inProp, setInProp] = useState(false);

    useEffect(() => {
      !inProp && setInProp(true);
    }, [inProp]);

    return (
      <Transition in={inProp} timeout={1500}>
        <div className="forms-container">
          <FormsButton
            primaryColor={currentTour.styles.primaryColor}
            openModal={closeModal}
          />

          <DialogModal
            closeModal={closeModal}
            isOpen={shouldShowForm}
            aria={{
              label: `Form modal: ${currentForm.formName}`,
            }}
            id="form-modal"
            className="form-modal"
            shouldCloseOnOverlayClick
          >
            <EmbeddedForm
              name={currentForm.formName}
              description={currentForm.formDescription}
              type={currentForm?.formType}
              formEmbedCode={currentForm.formEmbedCode}
              publicTour={publicTour}
              classes='tour-forms-container__public-tour'
            />
          </DialogModal>
        </div>
      </Transition>
    );
  }
);

FormModal.propTypes = {
  currentForm: PropTypes.object,
  currentTour: PropTypes.object,
  closeModal: PropTypes.func.isRequired,
  publicTour: PropTypes.bool,
  shouldShowForm: PropTypes.bool,
};

export default FormModal;
